"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceType = exports.TariffPlanStatus = exports.segment = exports.tariffPlanType = exports.brand = exports.unitOfMeasurement = exports.energyType = exports.type = void 0;
/**
 * Type of tariff.
 */
exports.type = {
    MARKET_PRICE: 'MARKET_PRICE',
    PURCHASING_FEE: 'PURCHASING_FEE',
    TAX: 'TAX'
};
/**
 * Energy type.
 */
exports.energyType = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * Unit of measurement.
 */
exports.unitOfMeasurement = {
    M3: 'm³',
    KWH: 'kWh'
};
exports.brand = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
exports.tariffPlanType = {
    FIXED: 'fixed',
    DYNAMIC: 'dynamic',
    VARIABLE: 'variable'
};
exports.segment = {
    HOUSEHOLD: 'household',
    SMALL_OFFICE_HOME_OFFICE: 'small_office_home_office',
    SMALL_MEDIUM_ENTERPRISE: 'small_medium_enterprise',
    SPECIAL: 'special',
    RENTALS: 'rentals'
};
exports.TariffPlanStatus = {
    CONCEPT: 'concept',
    AWAITING_APPROVAL: 'awaiting-approval',
    APPROVED: 'approved',
    PUBLISHED: 'published',
    REVOKED: 'revoked',
    REJECTED: 'rejected'
};
exports.PriceType = {
    SINGLE_PRICE: 'singlePrice',
    PEAK_PRICE: 'peakPrice',
    OFF_PEAK_PRICE: 'offPeakPrice',
    FIXED_COSTS: 'fixedCosts',
    MONO_FUEL_SURCHARGE: 'monoFuelSurcharge',
    PV_SCALES: 'pvScales'
};
